export const SYSTEM_COLORS = Object.freeze({
    BLACK: {
        BLACK_4_PERCENT: "rgba(0, 0, 0, 0.04)",
        BLACK_8_PERCENT: "rgba(0, 0, 0, 0.08)",
        BLACK_10_PERCENT: "rgba(0, 0, 0, 0.10)",
        BLACK_12_PERCENT: "rgba(0, 0, 0, 0.12)",
        BLACK_12_5_PERCENT: "rgba(0, 0, 0, 0.125)",
        BLACK_16_PERCENT: "rgba(0, 0, 0, 0.16)",
        BLACK_25_PERCENT: "rgba(0,0,0,0.25)",
        DARK_NAVY: "#111827",
        DARK_NAVY_12: "rgba(17, 24, 39, 0.12)",        
        EERIE_BLACK: "#1a1a1a",
        GUNMETAL: "#1F2937",        
        JET: "#333"
    },
    BLUE: {
        CORNFLOWER: "#e5e7eb",
        OCEAN_BLUE: "#3B82A0",
        SLATE: "#6B7A90",        
    },
    GRAY: {
        ALTO: "#e8e8e8",
        ANTI_FLASH: "#EEF0F3",
        BLUE_GRAY: "#9ca3af",
        CHARCOAL_GRAY: "#374151",
        CHARCOAL: "#4a4a4a",
        CLOUD_GRAY: "#eff1f4",
        COOL_GRAY: "#d1d5db",
        COOL_LIGHT_GRAY: "#bbbcbd",
        CULTURED: "#f0f0f0",
        DARK_GRAY: "#aaa",
        DAVY_GRAY: "#555",
        DIM_GRAY: "#777",
        GAINSBORO: "#ddd",
        GRAY_50: "#f9fafb",
        GRAY_187: "#bbb",
        GRAY_200: "#e5e7eb",
        GREY: "#999",
        LIGHT_GRAY: "#e5e5e5",
        LIGHT_SILVER: "#ccc",
        MEDIUM_GRAY: "#666",
        MIST: "#ececec",
        NEUTRAL_GRAY: "#8a8a8a",
        ONYX: "#444",
        PLATINUM: "#eee",
        PEARL_GRAY: "#e1e3e6",
        SILVER: "#e0e0e0",
        SILVER_SAND: "#d0d0d0",
        SLATE_GRAY: "#6b6b6b",
        SOFT_GRAY: "#9a9a9a",
        SONIC_SILVER: "#5c5c5c",
        SPANISH_GRAY: "#919191",
        STONE_100: "#f5f5f4",
        TAUPE_GRAY: "#888",
        WARM_GRAY: "#e6e3df",
        ZINC_100: "#f3f4f6",
        ZINC_700: "#3f3f46"
    },
    GREEN: {
        DARK_FOREST: "#14532d",
        FOREST_GREEN: "#1e8a42",
        FOREST_GREEN_2: "rgba(30,138,66,0.2)",
        FOREST_GREEN_8: "rgba(30,138,66,0.08)",
        FOREST_GREEN_10: "rgba(30, 138, 66, 0.1)",
        HONEYDEW: "#effbf5",
        JADE: "#1e9e62",
        MINT: "#bdebd3",
        MINT_LIGHT: "#d4f5e3",        
    },
    ORANGE: {
        APRICOT: "#FED7AA",
        APRICOT_MIST: "#f5e3da",
        BURNT_ORANGE: "#e8773a",
        BURNT_ORANGE_8: "rgba(232, 119, 58, 0.08)",
        BURNT_ORANGE_12: "rgba(232, 119, 58, 0.12)",
        BURNT_ORANGE_40: "rgba(232, 119, 58, 0.4)",
        CINNABAR: "#E2603B",
        DARK_ORANGE: "#ec5924",
        DEEP_ORANGE: "#d94d1c",
        LIGHT_BURNT_ORANGE: "#ed8d5a",
        MELON: "#f5cdb9",
        PEACH: "#FFEDD5",
        PEACH_CREAM: "#fbe9df",
        PEACH_FUZZ: "#fbece5",
        TANGERINE: "#F97316",
        TERRACOTTA_8: "rgba(196, 115, 72, 0.08)",        
        RUST: "#C2410C",
    },
    RED: {
        BRICK_RED: "#e05252",
        BRICK_RED_025: "rgba(224,82,82,0.25)",
        BRICK_RED_8: "rgba(224,82,82,0.08)",
        BRICK_RED_10: "rgba(224, 82, 82, 0.1)",
        BRICK_RED_12: "rgba(224, 82, 82, 0.12)",
        CARDINAL: "#e53935",
        CORAL_RED: "#EC6552",
        CRIMSON: "#DC2626",
        FIREBRICK: "#B91C1C",
        MISTY_ROSE: "#FEE2E2",
        SALMON_PINK: "#FECACA",
    },
    WHITE: {
        ALABASTER: "#f2f2f0",
        ALMOND: "#F1DDD4",
        BLUSH: "#fdf3ee",
        BONE: "#e0ddd6",
        CLOUD: "#f8f9f9",
        OFF_WHITE: "#fdfcfb",
        LINEN: "#fdf1ec",
        PEARL: "#ececea",
        PORCELAIN: "#f4f4f2",
        SEASHELL: "#fff6f0",
        SHELL: "#f3e4dc",
        SNOW: "#f9f9f7",        
        WARM_WHITE: "#f4f3f1",
        WHITE: "#fff",
        WHITE_SMOKE: "#fafafa"
    },
    YELLOW: {
        AMBER: "#eab308",
        DARK_OCHRE: "#A16207",
        LEMON: "#FEF08A",
        OCHRE: "#b58a00",
        OCHRE_10: "rgba(181, 138, 0, 0.1)",
        PALE_YELLOW: "#FEF9C3",
    }    
});
